/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminImageRotateDirection = {
    RotateClockwise: 'clockwise',
    RotateCounterclockwise: 'counterclockwise'
} as const;
export type AdminImageRotateDirection = typeof AdminImageRotateDirection[keyof typeof AdminImageRotateDirection];


export function instanceOfAdminImageRotateDirection(value: any): boolean {
    for (const key in AdminImageRotateDirection) {
        if (Object.prototype.hasOwnProperty.call(AdminImageRotateDirection, key)) {
            if (AdminImageRotateDirection[key as keyof typeof AdminImageRotateDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminImageRotateDirectionFromJSON(json: any): AdminImageRotateDirection {
    return AdminImageRotateDirectionFromJSONTyped(json, false);
}

export function AdminImageRotateDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImageRotateDirection {
    return json as AdminImageRotateDirection;
}

export function AdminImageRotateDirectionToJSON(value?: AdminImageRotateDirection | null): any {
    return value as any;
}

export function AdminImageRotateDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminImageRotateDirection {
    return value as AdminImageRotateDirection;
}

